// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as PartnerTicketsViewHelper from "../../components/driver-records/utils/PartnerTicketsViewHelper.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getView(tickets, dispatch) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: tickets,
              children: (function (ticketList) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: PartnerTicketsViewHelper.getColumnSchema(dispatch),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(ticketList, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getView ,
  
}
/* react Not a pure module */
